import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function OverviewTab({ id }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    endpoints.overview(id).then((r) => setData(r.data));
    const t = setInterval(() => endpoints.overview(id).then((r) => setData(r.data)), 3000);
    return () => clearInterval(t);
  }, [id]);

  const p = data?.profile;
  if (!p) return <div className="text-sm text-muted-foreground">Waiting for dataset profile…</div>;

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="ROWS" value={p.n_rows} />
        <Stat label="COLUMNS" value={p.n_cols} />
        <Stat label="MISSING" value={`${p.missing_pct}%`} />
        <Stat label="QUALITY" value={p.quality_score} highlight />
      </div>

      <div>
        <div className="label-mono mb-3">// COLUMNS</div>
        <div className="border border-border rounded-sm overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-secondary/40">
                <TableHead className="text-xs">Name</TableHead>
                <TableHead className="text-xs">Type</TableHead>
                <TableHead className="text-xs text-right">Missing</TableHead>
                <TableHead className="text-xs text-right">Unique</TableHead>
                <TableHead className="text-xs text-right">Mean / Top</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {p.columns.map((c) => (
                <TableRow key={c.name} data-testid={`col-row-${c.name}`}>
                  <TableCell className="font-mono text-xs">{c.name}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{c.inferred_type}</TableCell>
                  <TableCell className="num text-xs text-right">{c.missing_pct}%</TableCell>
                  <TableCell className="num text-xs text-right">{c.unique}</TableCell>
                  <TableCell className="num text-xs text-right text-muted-foreground max-w-[220px] truncate">
                    {c.mean !== undefined ? `μ=${c.mean}` : c.top_values ? c.top_values.map((v) => v.value).join(", ") : "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>

      {p.sample?.length > 0 && (
        <div>
          <div className="label-mono mb-3">// SAMPLE ROWS</div>
          <div className="border border-border rounded-sm overflow-auto">
            <table className="w-full text-xs">
              <thead className="bg-secondary/40">
                <tr>
                  {Object.keys(p.sample[0]).map((k) => (
                    <th key={k} className="px-3 py-2 text-left font-mono font-normal text-muted-foreground">{k}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {p.sample.map((row, i) => (
                  <tr key={i} className="border-t border-border">
                    {Object.values(row).map((v, j) => (
                      <td key={j} className="px-3 py-2 font-mono truncate max-w-[180px]">{String(v).slice(0, 40)}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <div className={`border border-border p-4 rounded-sm bg-card ${highlight ? "glow-amber border-accent/40" : ""}`}>
      <div className="label-mono">{label}</div>
      <div className={`num font-display font-bold text-2xl mt-1 ${highlight ? "text-accent" : ""}`}>{value}</div>
    </div>
  );
}
